function isMfaChallengeResponse(data) {
    return Boolean(data && data.mfaRequired === true && data.mfa && data.mfa.token);
}

function isFinalLoginResponse(data) {
    return Boolean(data && data.success === true && !isMfaChallengeResponse(data));
}

module.exports = {
    isFinalLoginResponse,
    isMfaChallengeResponse,
};
